import { render, staticRenderFns } from "./PageMemberConnect.vue?vue&type=template&id=220c4ae4"
import script from "./PageMemberConnect.vue?vue&type=script&lang=js"
export * from "./PageMemberConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports